<template>
  <el-alert
    v-if="shopCtx.listTip"
    class="mb-3!"
    :title="shopCtx.listTip"
    :type="shopCtx.multiSelfAbnormal || shopCtx.emptySelfShops ? 'warning' : 'info'"
    show-icon
    :closable="false"
  />
  <ContentWrap>
    <el-form ref="queryFormRef" :inline="true" :model="queryParams" label-width="80px">
      <el-form-item
        v-if="shopCtx.selfScope ? shopCtx.multiSelfAbnormal : false"
        label="所属店铺"
        prop="shopId"
      >
        <el-select
          v-model="selectedShopId"
          class="!w-220px"
          clearable
          filterable
          placeholder="全部自营店汇总"
        >
          <el-option
            v-for="item in shopFilterOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="订单号" prop="orderNo">
        <el-input
          v-model="queryParams.orderNo"
          class="!w-220px"
          clearable
          placeholder="订单流水号"
          @keyup.enter="handleQuery"
        />
      </el-form-item>
      <el-form-item label="用户" prop="userId">
        <el-select v-model="queryParams.userId" class="!w-240px" filterable clearable placeholder="请选择用户">
          <el-option v-for="u in staffOptions" :key="u.value" :label="u.label" :value="u.value" />
        </el-select>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-select v-model="queryParams.status" class="!w-160px" clearable placeholder="全部">
          <el-option label="申请中" :value="0" />
          <el-option label="已开具" :value="10" />
          <el-option label="已驳回" :value="20" />
          <el-option label="已取消" :value="30" />
        </el-select>
      </el-form-item>
      <el-form-item label="申请时间" prop="createTime">
        <el-date-picker
          v-model="queryParams.createTime"
          type="datetimerange"
          value-format="YYYY-MM-DD HH:mm:ss"
          start-placeholder="开始"
          end-placeholder="结束"
          class="!w-360px"
        />
      </el-form-item>
      <el-form-item>
        <el-button @click="handleQuery"><Icon icon="ep:search" class="mr-5px" />搜索</el-button>
        <el-button @click="resetQuery"><Icon icon="ep:refresh" class="mr-5px" />重置</el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>

  <ContentWrap>
    <el-table v-loading="loading" :data="list">
      <el-table-column label="编号" prop="id" width="80" />
      <el-table-column label="订单号" prop="orderNo" min-width="160" />
      <el-table-column label="用户" prop="userId" width="90" />
      <el-table-column label="金额" prop="price" width="100">
        <template #default="{ row }">¥{{ ((row.price || 0) / 100).toFixed(2) }}</template>
      </el-table-column>
      <el-table-column label="抬头" min-width="140">
        <template #default="{ row }">
          <div>{{ row.title }}</div>
          <div class="text-12px text-gray-400">{{ row.titleType === 2 ? '企业' : '个人' }}</div>
        </template>
      </el-table-column>
      <el-table-column label="邮箱" prop="email" min-width="160" />
      <el-table-column label="税号" prop="taxNo" min-width="140" show-overflow-tooltip />
      <el-table-column label="状态" prop="status" width="90">
        <template #default="{ row }">
          <el-tag v-if="row.status === 0" type="warning">申请中</el-tag>
          <el-tag v-else-if="row.status === 10" type="success">已开具</el-tag>
          <el-tag v-else-if="row.status === 20" type="danger">已驳回</el-tag>
          <el-tag v-else type="info">已取消</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="发票号" prop="invoiceNo" min-width="120" show-overflow-tooltip />
      <el-table-column
        label="申请时间"
        prop="createTime"
        width="170"
        :formatter="dateFormatter"
      />
      <el-table-column label="操作" width="160" fixed="right">
        <template #default="{ row }">
          <el-button link type="primary" @click="openDetail(row)">详情</el-button>
          <el-button
            v-if="row.status === 0"
            link
            type="success"
            v-hasPermi="['trade:invoice:issue']"
            @click="openIssue(row)"
          >
            开具
          </el-button>
          <el-button
            v-if="row.status === 0"
            link
            type="danger"
            v-hasPermi="['trade:invoice:reject']"
            @click="openReject(row)"
          >
            驳回
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-model:limit="queryParams.pageSize"
      v-model:page="queryParams.pageNo"
      :total="total"
      @pagination="getList"
    />
  </ContentWrap>

  <el-dialog v-model="detailVisible" title="开票详情" width="560px">
    <el-descriptions v-if="current" :column="1" border>
      <el-descriptions-item label="订单号">{{ current.orderNo }}</el-descriptions-item>
      <el-descriptions-item label="金额">
        ¥{{ ((current.price || 0) / 100).toFixed(2) }}
      </el-descriptions-item>
      <el-descriptions-item label="抬头">{{ current.title }}</el-descriptions-item>
      <el-descriptions-item label="税号">{{ current.taxNo || '-' }}</el-descriptions-item>
      <el-descriptions-item label="邮箱">{{ current.email }}</el-descriptions-item>
      <el-descriptions-item label="开户行">{{ current.bankName || '-' }}</el-descriptions-item>
      <el-descriptions-item label="账号">{{ current.bankAccount || '-' }}</el-descriptions-item>
      <el-descriptions-item label="地址">{{ current.companyAddress || '-' }}</el-descriptions-item>
      <el-descriptions-item label="电话">{{ current.companyPhone || '-' }}</el-descriptions-item>
      <el-descriptions-item label="发票号">{{ current.invoiceNo || '-' }}</el-descriptions-item>
      <el-descriptions-item label="附件">
        <el-link v-if="current.invoiceUrl" :href="current.invoiceUrl" target="_blank" type="primary">
          打开
        </el-link>
        <span v-else>-</span>
      </el-descriptions-item>
      <el-descriptions-item label="驳回原因">{{ current.rejectReason || '-' }}</el-descriptions-item>
      <el-descriptions-item label="备注">{{ current.adminRemark || '-' }}</el-descriptions-item>
    </el-descriptions>
  </el-dialog>

  <el-dialog v-model="issueVisible" title="开具发票" width="520px">
    <el-form label-width="100px">
      <el-form-item label="发票号码">
        <el-input v-model="issueForm.invoiceNo" placeholder="选填" />
      </el-form-item>
      <el-form-item label="发票附件">
        <UploadFile
          v-model="issueForm.invoiceUrl"
          :file-type="['pdf', 'png', 'jpg', 'jpeg']"
          :file-size="20"
          :limit="1"
          :is-show-tip="true"
          :use-material-library="false"
          :replace-on-exceed="true"
          directory="mall/invoice"
        />
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="issueForm.adminRemark" type="textarea" placeholder="选填" />
      </el-form-item>
      <el-alert
        type="info"
        :closable="false"
        title="人工台账：请线下将发票发送至用户邮箱后，再点确认开具。"
      />
    </el-form>
    <template #footer>
      <el-button @click="issueVisible = false">取消</el-button>
      <el-button type="primary" :loading="submitting" @click="submitIssue">确认开具</el-button>
    </template>
  </el-dialog>

  <el-dialog v-model="rejectVisible" title="驳回申请" width="480px">
    <el-form label-width="100px">
      <el-form-item label="驳回原因" required>
        <el-input v-model="rejectForm.rejectReason" type="textarea" placeholder="必填" />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="rejectVisible = false">取消</el-button>
      <el-button type="danger" :loading="submitting" @click="submitReject">确认驳回</el-button>
    </template>
  </el-dialog>
</template>

<script setup lang="ts">
import { dateFormatter } from '@/utils/formatTime'
import * as InvoiceApi from '@/api/mall/trade/invoice'
import { useMallSelfShopContext } from '@/hooks/web/useMallSelfShopContext'
import { UploadFile } from '@/components/UploadFile'

defineOptions({ name: 'TradeInvoice' })

const { staffOptions, staffMap, loadStaffs } = useStaff()
const message = useMessage()
const {
  context: shopCtx,
  applyShopFilterToQuery,
  refresh: refreshShopCtx
} = useMallSelfShopContext()
const loading = ref(false)
const submitting = ref(false)
const list = ref<InvoiceApi.TradeInvoiceVO[]>([])
const total = ref(0)
const queryFormRef = ref()
const selectedShopId = ref<number | undefined>()
const shopFilterOptions = ref<{ id: number; name: string }[]>([])
const queryParams = reactive({
  pageNo: 1,
  pageSize: 10,
  orderNo: undefined as string | undefined,
  userId: undefined as string | number | undefined,
  status: undefined as number | undefined,
  createTime: [] as string[],
  shopId: undefined as number | undefined,
  shopIds: undefined as number[] | undefined
})

const detailVisible = ref(false)
const issueVisible = ref(false)
const rejectVisible = ref(false)
const current = ref<InvoiceApi.TradeInvoiceVO | null>(null)
const issueForm = reactive({ id: 0, invoiceNo: '', invoiceUrl: '', adminRemark: '' })
const rejectForm = reactive({ id: 0, rejectReason: '' })

const refreshShopFilterOptions = async () => {
  await refreshShopCtx()
  if (shopCtx.value.selfScope) {
    shopFilterOptions.value = shopCtx.value.shops.map((s) => ({
      id: s.id,
      name: s.name || `店铺${s.id}`
    }))
    if (shopCtx.value.singleShopId) {
      selectedShopId.value = shopCtx.value.singleShopId
    } else if (
      selectedShopId.value &&
      !shopFilterOptions.value.some((s) => s.id === selectedShopId.value)
    ) {
      selectedShopId.value = undefined
    }
  } else {
    shopFilterOptions.value = []
    selectedShopId.value = undefined
  }
}

const getList = async () => {
  loading.value = true
  try {
    const params = { ...queryParams } as Record<string, any>
    if (shopCtx.value.selfScope) {
      applyShopFilterToQuery(params, selectedShopId.value)
    } else {
      delete params.shopId
      delete params.shopIds
    }
    const data = await InvoiceApi.getInvoicePage(params)
    list.value = data.list || []
    total.value = data.total || 0
  } finally {
    loading.value = false
  }
}

const handleQuery = () => {
  queryParams.pageNo = 1
  getList()
}

const resetQuery = async () => {
  queryFormRef.value?.resetFields()
  await refreshShopFilterOptions()
  handleQuery()
}

const openDetail = (row: InvoiceApi.TradeInvoiceVO) => {
  current.value = row
  detailVisible.value = true
}

const openIssue = (row: InvoiceApi.TradeInvoiceVO) => {
  issueForm.id = row.id!
  issueForm.invoiceNo = ''
  issueForm.invoiceUrl = ''
  issueForm.adminRemark = ''
  issueVisible.value = true
}

const openReject = (row: InvoiceApi.TradeInvoiceVO) => {
  rejectForm.id = row.id!
  rejectForm.rejectReason = ''
  rejectVisible.value = true
}

const submitIssue = async () => {
  submitting.value = true
  try {
    await InvoiceApi.issueInvoice({ ...issueForm })
    message.success('已开具')
    issueVisible.value = false
    await getList()
  } finally {
    submitting.value = false
  }
}

const submitReject = async () => {
  if (!rejectForm.rejectReason?.trim()) {
    message.warning('请填写驳回原因')
    return
  }
  submitting.value = true
  try {
    await InvoiceApi.rejectInvoice({ ...rejectForm })
    message.success('已驳回')
    rejectVisible.value = false
    await getList()
  } finally {
    submitting.value = false
  }
}

watch(
  () => shopCtx.value.selfScope,
  async () => {
    await refreshShopFilterOptions()
    handleQuery()
  }
)

onMounted(async () => { loadStaffs();
  await refreshShopFilterOptions()
  await getList()
})
</script>
